import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { DomainActions } from '@app/core/actions';
import { DomainService } from '@app/core/services/domain.service';
import * as fromRoot from '@app/reducers';
import { select, Store } from '@ngrx/store';
import { Observable, ReplaySubject, Subject, of } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/constant';

@Injectable({
  providedIn: 'root'
})
export class LoadDomainGuard  {

  constructor(
    private store$: Store<fromRoot.State>,
    private readonly domainService: DomainService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true)
    }

    return this.loadDomain().pipe(map((domainLoaded: boolean) => {
      return domainLoaded;
    }));
  }

  loadDomain(): Observable<boolean> {
    const domainLoaded$ = new ReplaySubject<boolean>();
    const detectedDomain = this.domainService.detectDomain();
    const loadDomainError$ = new Subject();

    this.store$.pipe(
      select(fromRoot.getCurrentDomain),
      distinctUntilChanged(),
      takeUntil(domainLoaded$),
    ).subscribe((currentDomain: any) => {
      if (!!currentDomain && currentDomain.domain === detectedDomain) {
        domainLoaded$.next(true);
      } else {
        this.store$.dispatch(DomainActions.loadDomain({ id: detectedDomain }));
      }
    });

    this.store$.select(fromRoot.getLoadDomainError).pipe(
      takeUntil(loadDomainError$)
    ).subscribe((err: any) => {
      if (err && isPlatformBrowser(this.platformId)) {
        domainLoaded$.next(false);
        const [, ext] = document.location.hostname.match(Constant.regexpDomainExtension);
        window.location.href = document.location.protocol + '//' + Constant.redirection.main + ext + (window.location.port ? ':' + window.location.port : '');
      }
    });

    return domainLoaded$.asObservable();
  }
}
